import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import ReactQuill, { Quill } from "react-quill";
import { doPortChange, get, post, put } from "helpers/api_helper";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import UploadFile from "components/CommonLayouts/UploadFiles";
import * as api from "../../../constants/api_constants";
import { charactersOnly, zipcode } from "helpers/validations/regex";
import { charactersWithSpaces } from "helpers/validations/regex";
import { identificationNumber } from "helpers/validations/regex";
import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import { getAllCountries } from "helpers/utils/locationUtil";
import CustomAmountInput from "components/CustomInput/CustomAmountInput";
import { formatToPascal } from "helpers/utils/nameUtils";

function ViewReceivables() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [fetchedData, setFetchedData] = useState({});
  const [employees, setEmployees] = useState([]);

  const [countries, setCountries] = useState([{}]);
  const [customres, setCustomers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const fetchedCountries = await getAllCountries();

      const countriesWithLabelAndCurrency = fetchedCountries.map((country) => ({
        label: country.name,
        currency: country.currency,
      }));

      // Update the state with the processed data
      setCountries(countriesWithLabelAndCurrency);
      // console.log(countriesWithLabelAndCurrency);
    };

    fetchData();
  }, []);

  const employeeData = async () => {
    try {
      const response = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      const employeeResponse = response.map((item) => ({
        value: item.employeeId,
        label: `${item.firstName}  ${item.lastName}`,
        number: item.number,
        email: item.email,
      }));

      setEmployees(employeeResponse);
    } catch (error) {
      console.log("Error fetching employees data");
    }
  };
  useEffect(() => {
    employeeData();
    if (id) {
      fetchReceivedData(id);
    }
  }, [id]);

  const fetchReceivedData = async (id) => {
    try {
      const response = await get(api.GET_RECEIVABLE_BY_ID(id));
      const receivablesData = response?.data;
      // console.log(receivablesData);
      // console.log(response.data);
      const res = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      const employeeResponse = res.map((item) => ({
        value: item.employeeId,
        label: `${item.firstName}  ${item.lastName}`,
        department: item.department,
      }));
      const receivablesDat = response?.data;
      let temp = employeeResponse.find(
        (employee) => employee.label === receivablesDat?.name
      );
      let department = temp?.department;

      setFetchedData({
        from: receivablesData.field,
        name: receivablesData.name,
        department: formatToPascal(department),
        primaryContact: receivablesData.primaryContact,
        billingAddress: receivablesData.address,
        purpose: receivablesData.purpose,
        currency: receivablesData.currency,
        totalReceivableAmount: receivablesData.receivableAmount,
        adjustmentAmount: receivablesData.adjustmentAmount,
        receivedAmount: parseFloat(receivablesData.receivedAmount),
        amountDue: receivablesData.amountDue,
        status: receivablesData.receivableStatus,
        transactionMode: receivablesData.transactionMode,
        transactionNumber: receivablesData.transactionNumber,
        invoiceDate: receivablesData.invoiceDate,
        invoiceNumber: receivablesData.invoiceNumber,
        notes: receivablesData.notes,

        // invoiceAmount: receivablesData.invoiceAmount,
        // description: receivablesData.description,
        // source: receivablesData.source,
        // receivedDate: receivablesData.receivedDate,
        // receivedAmountTillDate: receivablesData.receivedAmountTillDate,
        // balanceAmount: receivablesData.balanceAmount,
        // dueDate: receivablesData.dueDate,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: id
      ? fetchedData
      : {
          from: "",
          name: "",
          billingAddress: "",
          receivedAmount: "",
          adjustmentAmount: "",
          purpose: "",
          description: "",
          source: "",
          receivedDate: "",
          primaryContact: "",
          invoiceNumber: "",
          invoiceDate: "",
          invoiceAmount: "",
          transactionMode: "",
          transactionNumber: "",
          amountDue: "",
          dueDate: "",
          status: "",
          receivedAmountTillDate: "",
          totalReceivableAmount: "",
          balanceAmount: "",
          notes: "",
        },
  });

  //  useEffect(() => {
  //     if(formik.values.from === "CUSTOMER"){
  //       let selectCustomer = customres.filter((customer) => customer.name === formik.values.name)
  //       console.log(selectCustomer)
  //       formik.setFieldValue("billingAddress", selectCustomer[0]?.address)
  //       formik.setFieldValue("name", selectCustomer[0]?.name)
  //     }

  //   },[formik.values.name])
  //   useEffect(() => {
  //     if(formik.values.from === "EMPLOYEE" || formik.values.from === "OTHERS"){
  //       formik.setFieldValue("billingAddress", "")
  //     }
  //   },[formik.values.from])

  return (
    <div className="page-content">
      <Container fluid={true} className="py-0 px-0">
        {id ? (
          <PageSubHeader
            heading={"View Receivables"}
            routePath={"Home"}
            pageName={"View Receivables"}
          />
        ) : (
          <PageSubHeader
            heading={"View Receivables"}
            routePath={"Home"}
            pageName={"View Receivables"}
          />
        )}

        <Row className="px-4 mx-0 my-3 ">
          <Col className="p-0 m-0" xs={12} md={12}>
            <Card>
              <CardBody>
                <Form
                  className="row g-3 needs-validation py-3"
                  onSubmit={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                ></Form>
                <Row className="card-group">
                  <Col xs={12} className="card-header">
                    <p className="form-header">Receivables Information</p>
                  </Col>
                  <Row className="card-group-body">
                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="from">
                          From
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="from"
                          type="text"
                          className="form-control"
                          id="from"
                          value={formik.values.from}
                          disabled
                        >
                          <option value="">Select</option>
                          <option value="CUSTOMER">Customer</option>
                          <option value="EMPLOYEE">Employee</option>
                          <option value="OTHERS">Others</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    {formik.values.from === "CUSTOMER" && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="name">Customer Name</Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            id="name"
                            value={formik.values.name || ""}
                            disabled
                          >
                            <option value="">Select</option>
                            {/* Add vendor options here */}
                          </Input>
                          {formik.touched.name && formik.errors.name ? (
                            <FormFeedback type="invalid">
                              {formik.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}
                    {/*condiational rendering for the extra input when employee is selected */}
                    {formik.values.from === "EMPLOYEE" && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="name">Employee Name</Label>
                          <Input
                            name="name"
                            type="select"
                            className="form-control"
                            id="name"
                            value={formik.values.name || ""}
                            disabled
                          >
                            <option value="">Select</option>
                            {employees.map((employee) => (
                              <option value={employee.label}>
                                {employee.label}
                              </option>
                            ))}
                          </Input>
                          {formik.touched.name && formik.errors.name ? (
                            <FormFeedback type="invalid">
                              {formik.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    {/* Conditionally render the extra input field when "OTHERS" is selected */}
                    {formik.values.from === "OTHERS" && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="name">
                            Name
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            id="name"
                            value={formik.values.name || ""}
                            disabled
                          />
                          {formik.touched.name && formik.errors.name ? (
                            <FormFeedback type="invalid">
                              {formik.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="billingAddress">
                          Address <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="billingAddress"
                          type="textarea"
                          className="form-control"
                          id="billingAddress"
                          value={formik.values.billingAddress}
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    {(formik.values.from === "EMPLOYEE" ||
                      formik.values.from === "OTHERS") && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="department">Department</Label>
                          <Input
                            name="department"
                            type="text"
                            className="form-control"
                            id="department"
                            value={formik.values.department || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.department &&
                              formik.errors.department
                                ? true
                                : false
                            }
                            disabled={
                              formik.values.from === "EMPLOYEE" ? true : false
                            }
                          >
                            <option value="">Select Department</option>
                            <option value="FINANCE">Finance</option>
                            <option value="DEVELOPMENT">Development</option>
                            <option value="HR">HR</option>
                            <option value="MARKETING_SALES">
                              Marketing & Sales
                            </option>
                            <option value="SUPPORT">Support</option>
                            <option value="TESTING">Testing</option>
                            <option value="ADMIN">Admin</option>
                            <option value="OTHERS">Others</option>
                          </Input>
                          {formik.touched.department &&
                          formik.errors.department ? (
                            <FormFeedback type="invalid">
                              {formik.errors.department}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="receivedAmount"
                        field="Recevied Amount"
                        type="text"
                        className=""
                        id="receivedAmount"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.receivedAmount || ""}
                        invalid={
                          formik.touched.receivedAmount &&
                          formik.errors.receivedAmount
                            ? true
                            : false
                        }
                        mandatory="yes"
                        disable="yes"
                      />
                    </Col>

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="receivedAmount">
                          Received Amount <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="receivedAmount"
                          type="number"
                          className="form-control"
                          id="receivedAmount"
                          value={formik.values.receivedAmount}
                          disabled
                        />
                      </FormGroup>
                    </Col> */}

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="adjustmentAmount"
                        field="Adjustment Amount"
                        type="text"
                        className=""
                        id="adjustmentAmount"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.adjustmentAmount || ""}
                        invalid={
                          formik.touched.adjustmentAmount &&
                          formik.errors.adjustmentAmount
                            ? true
                            : false
                        }
                        disable="yes"
                      />
                    </Col>

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="adjustmentAmount">
                          Adjustment Amount
                        </Label>
                        <Input
                          name="adjustmentAmount"
                          type="text"
                          className="form-control"
                          id="adjustmentAmount"
                          value={formik.values.adjustmentAmount || ""}
                          // onChange={formik.handleChange}
                          // onBlur={formik.handleBlur}
                          // invalid={
                          //   formik.touched.adjustmentAmount &&
                          //   formik.errors.adjustmentAmount
                          //     ? true
                          //     : false
                          // }
                          disabled
                        />
                        {formik.touched.adjustmentAmount &&
                        formik.errors.adjustmentAmount ? (
                          <FormFeedback type="invalid">
                            {formik.errors.adjustmentAmount}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col> */}

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="purpose">
                          Purpose <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="purpose"
                          type="text"
                          className="form-control"
                          id="purpose"
                          value={formik.values.purpose || ""}
                          disabled
                        >
                          <option value="">Select Purpose</option>
                          <option value="ADVANCE_PAY_ROLL">
                            Advance Payroll
                          </option>
                          <option value="ATTORNEY_FEE">Attorney Fee</option>
                          <option value="VISA_FEE">Visa Fee</option>
                          <option value="PERSONAL_USE">Personal Use</option>
                          <option value="POSTAGE_FEE">Postage Fees</option>
                          <option value="MISC_FEE">Misc Fees</option>
                        </Input>
                        {formik.touched.purpose && formik.errors.purpose ? (
                          <FormFeedback type="invalid">
                            {formik.errors.purpose}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="description">
                          Description <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="description"
                          type="textarea"
                          className="form-control"
                          id="description"
                          value={formik.values.description}
                          disabled
                        />
                      </FormGroup>
                    </Col> */}

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="source">Source</Label>
                        <Input
                          name="source"
                          type="text"
                          className="form-control"
                          id="source"
                          value={formik.values.source || ""}
                          disabled
                        />
                        {formik.touched.source && formik.errors.source ? (
                          <FormFeedback type="invalid">
                            {formik.errors.source}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col> */}

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="receivedDate">
                          Received Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="receivedDate"
                          type="date"
                          className="form-control"
                          id="receivedDate"
                          value={formik.values.receivedDate}
                          disabled
                        />
                      </FormGroup>
                    </Col> */}

                    {(formik.values.from === "CUSTOMER" ||
                      formik.values.from === "OTHERS") && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="primaryContact">
                            Primary Contact{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="primaryContact"
                            type="text"
                            className="form-control"
                            id="primaryContact"
                            value={formik.values.primaryContact || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.primaryContact &&
                              formik.errors.primaryContact
                                ? true
                                : false
                            }
                            disabled
                          />
                          {formik.touched.primaryContact &&
                          formik.errors.primaryContact ? (
                            <FormFeedback type="invalid">
                              {formik.errors.primaryContact}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="invoiceNumber">Invoice #</Label>
                        <Input
                          name="invoiceNumber"
                          type="text"
                          className="form-control"
                          id="invoiceNumber"
                          value={formik.values.invoiceNumber}
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="invoiceDate">Invoice Date</Label>
                        <Input
                          name="invoiceDate"
                          type="date"
                          className="form-control"
                          id="invoiceDate"
                          value={formik.values.invoiceDate}
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="invoiceAmount"
                        field="Invoice Amount"
                        type="text"
                        className=""
                        id="invoiceAmount"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.invoiceAmount || ""}
                        invalid={
                          formik.touched.invoiceAmount &&
                          formik.errors.invoiceAmount
                            ? true
                            : false
                        }
                        disable="yes"
                      />
                    </Col>

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="invoiceAmount">Invoice Amount</Label>
                        <Input
                          name="invoiceAmount"
                          type="number"
                          className="form-control"
                          id="invoiceAmount"
                          value={formik.values.invoiceAmount}
                          disabled
                        />
                      </FormGroup>
                    </Col> */}

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="transactionMode">
                          Transaction Mode
                        </Label>
                        <Input
                          name="transactionMode"
                          type="text"
                          className="form-control"
                          id="transactionMode"
                          value={formik.values.transactionMode}
                          disabled
                        >
                          <option value="">Select Transaction Mode</option>
                          <option value="CHEQUE">Cheque</option>
                          <option value="BANK">Bank</option>
                          <option value="CASH">Cash</option>
                          <option value="CC">Credit/Debit</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="transactionNumber">Transaction #</Label>
                        <Input
                          name="transactionNumber"
                          type="text"
                          className="form-control"
                          id="transactionNumber"
                          value={formik.values.transactionNumber}
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="amountDue"
                        field="Due Amount"
                        type="text"
                        className=""
                        id="amountDue"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.amountDue || ""}
                        invalid={
                          formik.touched.amountDue && formik.errors.amountDue
                            ? true
                            : false
                        }
                        disable="yes"
                      />
                    </Col>

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="amountDue">
                          Amount Due <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="amountDue"
                          type="text"
                          className="form-control"
                          id="amountDue"
                          value={formik.values.amountDue || ""}
                          disabled
                        />
                        {formik.touched.amountDue && formik.errors.amountDue ? (
                          <FormFeedback type="invalid">
                            {formik.errors.amountDue}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col> */}

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="dueDate">
                          Due Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="dueDate"
                          type="date"
                          className="form-control"
                          id="dueDate"
                          value={formik.values.dueDate || ""}
                          disabled
                        />
                        {formik.touched.dueDate && formik.errors.dueDate ? (
                          <FormFeedback type="invalid">
                            {formik.errors.dueDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col> */}

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="status">
                          Status <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="status"
                          type="text"
                          className="form-control"
                          id="status"
                          value={formik.values.status || ""}
                          onChange={formik.handleChange} // Handle formik change for select input
                          disabled
                        >
                          <option value="">Select status</option>
                          <option value="RECEIVED">Recevied</option>
                          <option value="PARTIALLY_RECEIVED">
                            Partially Recevied
                          </option>
                          <option value="DRAFT">Draft</option>
                          {/* <option value="OVER_DUE">Over Due</option> */}
                        </Input>
                      </FormGroup>
                    </Col>

                    {/* <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="receivedAmountTillDate"
                        field="Recevied Amount Till Date"
                        type="text"
                        className=""
                        id="amountDue"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.receivedAmountTillDate || ""}
                        invalid={
                          formik.touched.receivedAmountTillDate &&
                          formik.errors.receivedAmountTillDate
                            ? true
                            : false
                        }
                        mandatory="yes"
                        disable="yes"
                      />
                    </Col> */}

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="totalReceivableAmount"
                        field="Total Recevied Amount"
                        type="text"
                        className=""
                        id="totalReceivableAmount"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.totalReceivableAmount || ""}
                        invalid={
                          formik.touched.totalReceivableAmount &&
                          formik.errors.totalReceivableAmount
                            ? true
                            : false
                        }
                        mandatory="yes"
                        disable="yes"
                      />
                    </Col>

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="balanceAmount"
                        field="Balance Amount"
                        type="text"
                        className=""
                        id="balanceAmount"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.balanceAmount || ""}
                        invalid={
                          formik.touched.balanceAmount &&
                          formik.errors.balanceAmount
                            ? true
                            : false
                        }
                        disable="yes"
                        // mandatory="yes"
                      />
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="notes">Notes</Label>
                        <Input
                          name="notes"
                          type="textarea"
                          className="form-control"
                          id="notes"
                          value={formik.values.notes}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer
        saveText="Edit Receivables"
        save={() => navigate(`/add-receivables/${id}`)}
        showBackConfirmation={false}
      />{" "}
    </div>
  );
}

export default ViewReceivables;